import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { BetType } from '~/vendor/cxy/components/BetType';

import styles from './styles/BetTypeLabels.module.css';

export const BetTypeLabel = ({
  shouldShowLabel = true,
  size,
  type,
  ...props
}: Omit<ComponentProps<typeof BetType>, 'variant' | 'label'> & { shouldShowLabel?: boolean; type: string }) => {
  const { t } = useTranslation();

  if (type === 'HOTTEST') {
    return (
      <span className={styles.betTypeLabel}>
        {shouldShowLabel && t('CX_PLUS_HOTTEST')}
        <BetType variant={type} {...props} label={t('CX_PLUS_BS_HOTTEST_LABEL')} size={size} />
      </span>
    );
  }

  if (type === 'DIAMOND_IN_THE_ROUGH') {
    return (
      <span className={styles.betTypeLabel}>
        {shouldShowLabel && t('CX_PLUS_BETTYPE_DIAMOND')}
        <BetType variant={type} {...props} label={t('CX_PLUS_BS_DIAMOND_LABEL')} size={size} />
      </span>
    );
  }

  return null;
};
